import { AbstractPageDataProvider } from "@/lib/utility/data/page-data-provider.abstract";
import { IPageViewModel } from "@/lib/utility/data/page-view-model.interface";
import { IDocumentRuleCheck } from "@/models/document-rule-check.entity";
import documentRuleCheckService from "@/services/mrfiktiv/services/documentRuleCheckService";
import { MrfiktivDocumentRuleCheckControllerGetParamsGen } from "@/services/mrfiktiv/v1/data-contracts";

export const DocumentRuleCheckPageDataProvider = new (class extends AbstractPageDataProvider<
  IDocumentRuleCheck,
  MrfiktivDocumentRuleCheckControllerGetParamsGen
> {
  itemsPerPage = 25;

  async getPage(query: MrfiktivDocumentRuleCheckControllerGetParamsGen): Promise<IPageViewModel<IDocumentRuleCheck>> {
    const res = await documentRuleCheckService.get(query);

    const meta = res.meta;
    const data = (res.data ?? []) as IDocumentRuleCheck[];

    return { meta, data };
  }
})();
